/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PhysicianGroupViewModel } from './PhysicianGroupViewModel'; 

export function getPhysicianGroupOptions(id: string, onSuccess?: (result: PhysicianGroupViewModel) => void) {
	return queryOptions({
		queryKey: ['physician-group', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/physicians/queries/getphysiciangroup/' + id;
			const resp = await axios.get<PhysicianGroupViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}